import { merchandisingLabels } from '@/core/tamagoshi/MerchandisingTag/interfaces';
import { LabelVariant } from '@/core/tamagoshiTailwind/components/Label/Label';
import { getPromoLabelData } from '@/productDiscovery/CommercialAnimation/components/PromoLabel/PromoLabel';
import { ProductCardData } from '@/productDiscovery/productCards/interfaces/productCardData';
import {
  secondHandLabel,
  selectionManomano,
  topSaleLabel,
} from '@/productDiscovery/productCards/translations/translations';

export const getProductLabelData = (product: ProductCardData) => {
  let productLabelData = undefined;

  if (
    product.commercialAnimation &&
    product.commercialAnimation.tags &&
    product.commercialAnimation.tags.length > 0
  ) {
    productLabelData = getPromoLabelData(
      product.commercialAnimation.tags,
      product.price,
    );
  }

  if (
    !productLabelData ||
    productLabelData.promoType === merchandisingLabels.PROMO
  ) {
    if (product.isTopSale) {
      return {
        labelText: topSaleLabel,
        labelVariant: 'BrandSecondary' as LabelVariant,
        promoType: undefined,
      };
    }
    if (product.isSelectionManomano) {
      return {
        labelText: selectionManomano,
        labelVariant: 'BrandSecondary' as LabelVariant,
        promoType: undefined,
      };
    }
    if (product.isSecondHand) {
      return {
        labelText: secondHandLabel,
        labelVariant: 'SuccessPrimary' as LabelVariant,
        promoType: undefined,
      };
    }
  }

  return productLabelData;
};
